<template>
  <div class="baidumap-options-setting">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="背景" name="1">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
          >
            <div class="content">
              <div class="content-item mb16">
                <cx-background :background.sync="background" imgType="10" />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="边框" name="2">
          <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content">
              <div class="content-item mb16">
                <cx-check-box :value.sync="showDayBorder">显示边框</cx-check-box>
                <div class="verticallyCenter" v-if="showDayBorder">
                  <cx-border
                      :borderWidth.sync="borderWidth"
                      :borderStyle.sync="borderStyle"
                      :borderColor.sync="borderColor"
                      :borderIsThemeColor.sync="borderIsThemeColor"
                  />
                </div>
              </div>
              <div class="content-item mb16">
                <border-radius
                    :borderTypeFlag.sync="borderTypeFlag"
                    :borderRadius.sync="borderRadius"
                    :borderTopLeftRadius.sync="borderTopLeftRadius"
                    :borderTopRightRadius.sync="borderTopRightRadius"
                    :borderBottomRightRadius.sync="borderBottomRightRadius"
                    :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" title="边距" name="3">
          <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content">
              <div class="content-item mb16">
                <cx-padding
                    :paddingTypeFlag.sync="paddingTypeFlag"
                    :padding.sync="padding"
                    :paddingTop.sync="paddingTop"
                    :paddingRight.sync="paddingRight"
                    :paddingBottom.sync="paddingBottom"
                    :paddingLeft.sync="paddingLeft"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')" title="更多" name="4">
          <div
              class="setting-item"
              v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="content">
              <div class="content-item mb16">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>

              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span
                      v-show="borderShadowChecked"
                      class="icon-portal-plus theme-color right-icon"
                      @click="addBoxshadow"
                  ></span>
                </div>
                <box-shadow
                    v-show="borderShadowChecked"
                    :boxShadowH.sync="boxShadowH"
                    :boxShadowV.sync="boxShadowV"
                    :boxShadowBlur.sync="boxShadowBlur"
                    :boxShadowSpread.sync="boxShadowSpread"
                    :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          v-show="$store.state.states.showPluginSetting"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '10')"
          title="插件"
          name="10"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '10')"
          >
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"

import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import { withMethodsHistoryCombine } from "utils/revork"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "baidumap-options-setting",
  components: {
    controlWidthAndSizeAndZindex,
    widthAndSizeAndZindex,
    elementPluginSetting,
    publicStyle
  },
  props: { options: Object },
  data() {
    return {
      isAdmin: false,
      activeNames: ["1"],
      collapseActiveNames: ["1"],
      allCollapseNames: ["1"],
      borderShadowChecked: true,
    }
  },
  watch: {

  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    styleId() {
      return this.options.styleId || 1
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: "#fff"
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    showDayBorder: {
      get() {
        return this.options.showDayBorder || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showDayBorder", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        return this.options.borderTypeFlag || 2
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderRadius
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
              [newVal, newVal, newVal, newVal, newVal],
              [
                "borderTopLeftRadius",
                "borderTopRightRadius",
                "borderBottomLeftRadius",
                "borderBottomRightRadius",
                "borderRadius"
              ],
              false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderRadius", false)
        }
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius || 0
      },
      set(newVal) {
        if (this.borderTypeFlag === 2) {
          this.$changeOptionsEV(
              [parseInt(newVal), parseInt(newVal), parseInt(newVal), newVal],
              ["borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius", "borderTopLeftRadius"],
              false
          )
        } else {
          this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
        }
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
// 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 2
        if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
          defaultType = 1
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    opacity : {
      get() {
        return this.options.opacity * 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "opacity", false)
      }
    },
    //阴影
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
    this.isAdmin = this.$store.state.states.managerType === 1 ? true : false

  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },


  }
})
</script>

<style scoped lang="scss">

</style>
